// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9261b1da","455":"e8081c64","977":"477803bd"}[chunkId] + ".chunk.js";
};